import { useEffect, useRef, useState } from "react";
import { X } from "lucide-react";

// Branded replacement for window.prompt(). Controlled: render when `open` is true.
export function PromptDialog({ open, title, label, placeholder = "", defaultValue = "", confirmText = "Save", onSubmit, onClose }) {
  const [value, setValue] = useState(defaultValue);
  const inputRef = useRef(null);
  useEffect(() => { if (open) { setValue(defaultValue); setTimeout(() => inputRef.current?.focus(), 50); } }, [open, defaultValue]);
  if (!open) return null;
  const submit = () => { const v = value.trim(); if (!v) return; onSubmit(v); };
  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[70] p-4" onClick={onClose} data-testid="prompt-dialog">
      <div className="bg-navy border border-white/15 w-full max-w-sm p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h4 className="font-heading text-lg text-white">{title}</h4>
          <button onClick={onClose} aria-label="Close"><X size={18} className="text-gray-400 hover:text-white" /></button>
        </div>
        {label && <label className="block text-sm text-gray-400 mb-1.5">{label}</label>}
        <input ref={inputRef} value={value} onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") submit(); }} placeholder={placeholder} data-testid="prompt-dialog-input"
          className="w-full bg-navy-800 border border-white/20 text-white p-2.5 text-sm focus:border-gold focus:outline-none mb-5" />
        <div className="flex justify-end gap-2">
          <button onClick={onClose} data-testid="prompt-dialog-cancel" className="px-4 py-2 text-sm border border-white/20 text-gray-300 hover:bg-white/5 transition-colors">Cancel</button>
          <button onClick={submit} data-testid="prompt-dialog-confirm" className="px-4 py-2 text-sm bg-gold text-navy font-semibold hover:bg-gold-light transition-colors">{confirmText}</button>
        </div>
      </div>
    </div>
  );
}

export default PromptDialog;
